import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=50381dae&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=ts"
export * from "./CalendarView.vue?vue&type=script&lang=ts"
import style0 from "./CalendarView.vue?vue&type=style&index=0&id=50381dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50381dae",
  null
  
)

export default component.exports